import Vue from "vue";
import { ToastPlugin, ModalPlugin } from "bootstrap-vue";
import VueCompositionAPI from "@vue/composition-api";
import VueTheMask from "vue-the-mask";

import router from "./router";
import store from "./store";
import App from "./App.vue";

import "./assets/scss/main.scss";

// Global Components
import "./global-components";

// 3rd party plugins
import "@axios";
import "@/libs/portal-vue";
import "@/libs/toastification";

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

// Composition API
Vue.use(VueCompositionAPI);

// import core styles
require("@core/scss/core.scss");

// import assets styles
require("@/assets/scss/style.scss");

// input mask
Vue.use(VueTheMask);

export const EventBus = new Vue();

Vue.config.productionTip = false;

export default new Vue({
	router,
	store,
	render: h => h(App),
}).$mount("#app");
